import React, {lazy, Suspense} from 'react';

import {openWindow} from './utils/windowUtils';

const PrequalForm =  lazy(() => import("./pages/PrequalSinglePageApp/PrequalForm/PrequalForm"));
const TermsConditionsPage = lazy(() => import('./pages/Terms&ConditionsPage/Terms&ConditionsPage'));
const ErrorPage = lazy(() => import('./pages/ErrorPage/ErrorPage'));
const LoadingPage = lazy(() => import('./pages/Loading/LoadingPage'));
const DealerConnect = lazy(() => import('./components/DealerConnect/DealerConnect'));
const DealerConfirmation = lazy(() => import( './components/DealerConfirmation/DealerConfirmation'));
const PrequalReview = lazy(() => import('./pages/PrequalSinglePageApp/PrequalReview/PrequalReview'));
const ReviewOfferPage = lazy(() => import('./pages/ReviewOfferPage/ReviewOfferPage'));
const MaintenancePage = lazy(() => import('./pages/MaintenancePage/MaintenancePage'));
const DealerSubmission = lazy(() => import('./components/DealerSubmission/DealerSubmission'));
const AddressStandardization = lazy(() => import('./components/AddressStandardization/AddressStandardization'));
const renderLoader = () => <p>Loading</p>;

export default function RenderPage({customerData, appConfig, dispatch}) {
  switch (customerData.currentModalPage.value) {
    case '':
       return (<Suspense fallback={renderLoader()}>
        <PrequalForm
            appConfig={appConfig}
            customerData={customerData}
            dispatch={dispatch}
        />
      </Suspense>)

    case '/review':
        return (
            <Suspense fallback={renderLoader()}>
                <PrequalReview
                    appConfig={appConfig}
                    customerData={customerData}
                    dispatch={dispatch}
                />
            </Suspense>
        );

    case '/review-offer':
      return (
        <Suspense fallback={renderLoader()}>
          <ReviewOfferPage
            customerData={customerData}
            dispatch={dispatch}
            appConfig={appConfig}
          />
        </Suspense>
      );
    case '/error':
      return (
        <Suspense fallback={renderLoader()}><ErrorPage dispatch={dispatch} customerData={customerData} appConfig={appConfig} /></Suspense>);
    case '/maintenance':
      return (<Suspense fallback={renderLoader()}><MaintenancePage dispatch={dispatch} customerData={customerData}
                                                                   appConfig={appConfig}
                                                                   openWindow={openWindow} /></Suspense>);
      case '/standardization':
          return (<>
              <Suspense fallback={renderLoader()}><AddressStandardization appConfig={appConfig} customerData={customerData} dispatch={dispatch} /></Suspense>
              </>)
    case '/offer-loading':
      return (<>
          <Suspense fallback={renderLoader()}>
            <LoadingPage dispatch={dispatch} customerData={customerData}
                         appConfig={appConfig} />
          </Suspense>
        </>
      );
    case '/dealer-connect':
      return (
        <Suspense fallback={renderLoader()}>
          <DealerConnect dispatch={dispatch} appConfig={appConfig}
                         customerData={customerData} />
        </Suspense>
      );
    case '/dealer-connect-approved':
      return (<Suspense fallback={renderLoader()}><DealerConnect
        dispatch={dispatch}
        appConfig={appConfig}
        customerData={customerData}
        hasSelectButton
      /></Suspense>);
    case '/dealer-confirmation':
      return (<Suspense fallback={renderLoader()}><DealerConfirmation customerData={customerData} appConfig={appConfig}/></Suspense>);
    case '/dealer-submission':
      return (<Suspense fallback={renderLoader()}><DealerSubmission
        dispatch={dispatch}
        customerData={customerData}
        appConfig={appConfig}
      /></Suspense>);
    case '/terms-and-conditions':
      return (<Suspense fallback={renderLoader()}><TermsConditionsPage customerData={customerData} appConfig={appConfig} /></Suspense>);
    default:
      // handle default case
      break;
  }
}
